import React from 'react';
import DatePicker from 'react-datepicker';

const CIRCUITOS_INICIALES = [
    { circuito: "INICIO CIRCUITO ADMINISTRATIVO", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "LEGAL Y TÉCNICA (Debora/Paola/Mariela)", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "1º DCMDCGP. CONTABILIDAD - IMPUTACIÓN PRESUPUESTARIA - STR. o detalle nomenclatura (solicitud de gastos)", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "LEGAL Y TÉCNICA (puede o no hacer observaciones)", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "2º DSYSMHYFGP. SUBSIDIOS Y SUBENCIONES (primer organismo que puede hacer observaciones)", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "3º DLDSAGG. ASESORÍA (emite acta dictámen)", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "4º DLMDCCGP. CONTADURIA", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "5º SSAYCFDE. FISCALIA - VTA.", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "6º FIRMA CONVENIO", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "7º RESO. Nº", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "8º SSAYCFDE. NOTIFICACION FISCAL", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "9º INICIO EXPTE. DE RENDICIÓN", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "10º ANTO. ENVÍO DE DOCUMENTACIÓN PARA EL PAGO A POLISTINA", fecha: null, orden: "", observaciones: "", nro_resolucion: "" },
    { circuito: "11º FECHA DE PAGO - INICIO PROCESO DE RENDICIÓN", fecha: null, orden: "", observaciones: "", nro_resolucion: "" }
];

const parseLocalDate = (dateInput) => {
    if (!dateInput) return null;
    if (dateInput instanceof Date) return dateInput;
    if (typeof dateInput === 'string') {
        if (dateInput.includes('T')) {
            const dateObj = new Date(dateInput);
            const userTimezoneOffset = dateObj.getTimezoneOffset() * 60000;
            return new Date(dateObj.getTime() + userTimezoneOffset);
        }
        const parts = dateInput.split('T')[0].split('-');
        if (parts.length === 3) {
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const day = parseInt(parts[2], 10);
            return new Date(year, month, day);
        }
    }
    return new Date(dateInput);
};

const inputClasses = "w-full p-2 border rounded dark:bg-gray-700 dark:text-white dark:border-gray-600 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all";

const CircuitoAdministrativo = ({ datos, onChange, disabled = false }) => {
    const items = CIRCUITOS_INICIALES.map(def => {
        const guardado = Array.isArray(datos) && datos.find(d => d.circuito === def.circuito);
        return guardado ? { ...def, ...guardado } : def;
    });

    const handleInputChange = (index, field, value) => {
        const nuevos = items.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        onChange(nuevos);
    };

    const esResolucion = (circuito) => {
        return circuito && circuito.includes("RESO");
    };

    return (
        <div className="mt-6 mb-6">
            <div className="overflow-x-auto rounded-lg border border-gray-300 dark:border-gray-600 shadow-sm relative">
                {disabled && (
                    <div className="absolute inset-0 bg-gray-200/30 dark:bg-gray-900/30 rounded-lg pointer-events-none" />
                )}
                    <table className="w-full table-fixed border-collapse">
                        <thead>
                            <tr className="bg-gray-100 dark:bg-gray-700">
                                <th className="border border-gray-300 dark:border-gray-600 px-4 py-2 w-12 text-center text-sm font-semibold text-gray-700 dark:text-gray-200">
                                    N°
                                </th>
                                <th className="border border-gray-300 dark:border-gray-600 px-4 py-2 w-80 text-left text-sm font-semibold text-gray-700 dark:text-gray-200">
                                    Circuito administrativo
                                </th>
                                <th className="border border-gray-300 dark:border-gray-600 px-4 py-2 w-40 text-left text-sm font-semibold text-gray-700 dark:text-gray-200">
                                    Fecha
                                </th>
                                <th className="border border-gray-300 dark:border-gray-600 px-4 py-2 w-20 text-center text-sm font-semibold text-gray-700 dark:text-gray-200">
                                    Orden
                                </th>
                                <th className="border border-gray-300 dark:border-gray-600 px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-gray-200">
                                    Observaciones
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, i) => {
                                const fechaDate = parseLocalDate(item.fecha);
                                const isReso = esResolucion(item.circuito);

                                return (
                                    <tr key={i} className="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                                        <td className="border border-gray-300 dark:border-gray-600 px-4 py-2 text-center">
                                            <span className="font-medium text-gray-800 dark:text-white">
                                                {i + 1}
                                            </span>
                                        </td>
                                        <td className="border border-gray-300 dark:border-gray-600 px-4 py-2 break-words">
                                            {isReso ? (
                                                <div className="flex items-center gap-1">
                                                    <span className="text-sm font-medium text-gray-700 dark:text-gray-200 truncate">
                                                        {item.circuito}
                                                    </span>
                                                    <input
                                                        type="text"
                                                        value={item.nro_resolucion || ''}
                                                        onChange={(e) => handleInputChange(i, 'nro_resolucion', e.target.value)}
                                                        disabled={disabled}
                                                        placeholder="Nº"
                                                        className={"w-24 " + inputClasses + " disabled:opacity-50 disabled:cursor-not-allowed"}
                                                    />
                                                </div>
                                            ) : (
                                                <span className="text-sm font-medium text-gray-700 dark:text-gray-200 line-clamp-2">
                                                    {item.circuito}
                                                </span>
                                            )}
                                        </td>
                                        <td className="border border-gray-300 dark:border-gray-600 px-4 py-2">
                                            <DatePicker
                                                selected={fechaDate}
                                                onChange={(date) => handleInputChange(i, 'fecha', date)}
                                                dateFormat="dd/MM/yyyy"
                                                className={inputClasses + " w-full disabled:opacity-50 disabled:cursor-not-allowed"}
                                                placeholderText="DD/MM/AAAA"
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={15}
                                                disabled={disabled}
                                            />
                                        </td>
                                        <td className="border border-gray-300 dark:border-gray-600 px-4 py-2 text-center">
                                            <input
                                                type="text"
                                                value={item.orden || ''}
                                                onChange={(e) => handleInputChange(i, 'orden', e.target.value)}
                                                disabled={disabled}
                                                placeholder="—"
                                                className={"w-16 text-center " + inputClasses + " disabled:opacity-50 disabled:cursor-not-allowed"}
                                            />
                                        </td>
                                        <td className="border border-gray-300 dark:border-gray-600 px-4 py-2">
                                            <div className="relative w-full">
                                                <textarea
                                                    value={item.observaciones || ''}
                                                    onChange={(e) => handleInputChange(i, 'observaciones', e.target.value)}
                                                    disabled={disabled}
                                                    placeholder="Añadir nota..."
                                                    maxLength="2500"
                                                    rows="1"
                                                    className={"resize-y min-h-[42px] max-h-[150px] pb-5 " + inputClasses + " disabled:opacity-50 disabled:cursor-not-allowed"}
                                                />
                                                <div className="absolute bottom-1.5 right-2 text-[10px] text-gray-400 dark:text-gray-500 pointer-events-none">
                                                    {(item.observaciones || '').length}/2500
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

        </div>
    );
};

export default CircuitoAdministrativo;
